// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, object, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { submit } from 'redux-form'

class FilterEmptyValues extends React.Component {
  static propTypes = {
    idRoot: string.isRequired,
    input: object.isRequired,
    filterSelect: string.isRequired,
    sourceForm: string.isRequired,
    submit: func.isRequired,
  }

  // checkbox label changes based on select's current value
  cbLabels = {
    antennaCode: 'Antenna',
    antennaModel: 'Antenna',
    asr: 'ASR',
    band: 'Frequency Bands',
    callSign: 'Call Sign',
    company: 'Company',
    radioCode: 'Radio',
    radioModel: 'Radio',
  }

  // based on the filter's selected set, the checkbox will
  // read and represent different things.
  getCbLabel = () => this.cbLabels[this.props.filterSelect]

  // NOTE - we're awaiting input.onChange because
  // we need to ensure that redux state is updated with this new
  // value before triggering submit
  onChange = async e => {
    const {
      input,
      sourceForm,
      submit,
    } = this.props
    await input.onChange(e)
    submit(sourceForm)
  }

  wrapperClasses = () => (
    `filter-empty-values-checkbox ${this.getCbLabel() ? '' : 'opacity-0'}`
  )

  render () {
    const { getCbLabel } = this

    const {
      idRoot,
      input,
    } = this.props

    return (
      <label className={this.wrapperClasses()}>
        <input
          {...input}
          id={`${idRoot}-checkbox`}
          disabled={!getCbLabel()}
          onChange={this.onChange}
          type={'checkbox'} />
        <span id={`${idRoot}-checkbox-label`}>
          {`Show all Paths with No Assigned ${getCbLabel()}`}
        </span>
      </label>
    )
  }
}

const mapStateToProps = ({ form }, { sourceForm }) => {
  const { filterSelect } = form[sourceForm].values

  return {
    filterSelect,
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    submit,
  }, dispatch)
)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterEmptyValues)
